module.exports = __webpack_public_path__ + "img/logo-text-color.9146cf19.png";